export default __webpack_public_path__ + "static/media/home-vertical-portfolio-img-03.bf78ae1b.jpg";